import React from 'react';
import Spinner from '@blockcatio/tabby-library/lib/components/Spinner';

const LoadingScreenModal = () => (
  <div className="loading-screen-modal">
    <p>
      Verifying Ethereum wallet, checking connection to Tabby Pay Smart Contract, and checking for
      Payments.
    </p>
    <Spinner message="Verifying..." loading />
  </div>
);

export default LoadingScreenModal;



// WEBPACK FOOTER //
// ./src/components/LoadingScreenModal.js